module.exports = __webpack_public_path__ + "static/media/licores.971c169b.jpg";